import React from "react";
import { FaQuoteLeft, FaStar } from "react-icons/fa";
import AboutBanner from "./AboutBanner";
import SisterConcerms from "./SisterConcerms";

const Testimonials = () => {
  // ৫টি রিভিউ ও ইউজার ইমেজের ডেটা
  const reviews = [
    {
      name: "Rahat Ahmed",
      text: "Iconic Greenland Limited helped me find the perfect plot for my dream home. Their documentation process is completely transparent and hassle-free.",
      role: "Plot Owner & Investor",
      image:
        "https://i.pinimg.com/736x/50/fb/44/50fb44943cd6de241e6ac46b8c4f378a.jpg",
      rating: 5,
    },
    {
      name: "Arafat Hossain",
      text: "I regularly travel with Iconic Express. Their service quality, comfort, and punctuality are truly unmatched in the transport industry.",
      role: "Regular Passenger",
      image:
        "https://i.pinimg.com/736x/4c/a8/c2/4ca8c289b3ee4dcf421008a40df6b7f1.jpg",
      rating: 5,
    },
    {
      name: "Tanvir Hossain",
      text: "Investing with Iconic Greenland was the best financial decision I made this year. The project location has high growth potential.",
      role: "Commercial Investor",
      image:
        "https://i.pinimg.com/736x/27/90/03/27900371354079f41e16751f2a320fdb.jpg",
      rating: 5,
    },
    {
      name: "Rakibul islam",
      text: "The legal verification process was smooth and very well explained by their professional legal team. Highly recommended!",
      role: "Residential Buyer",
      image:
        "https://i.pinimg.com/736x/7a/61/82/7a61821e4e9d78d57bf15ce86806b485.jpg",
      rating: 5,
    },
    {
      name: "Mahmudul Hasan",
      text: "Top-notch customer support! From booking to plot registration guidance, the team supported me at every step.",
      role: "NRI Investor",
      image:
        "https://i.pinimg.com/736x/ad/53/70/ad53706b10403051a011a86e3042682e.jpg",
      rating: 5,
    },
  ];

  return (
    <div className="bg-white overflow-hidden">
      {/* Hero Banner */}
      <AboutBanner
        title="CLIENT TESTIMONIALS"
        description="Hear from the valuable clients and passengers who have experienced our services."
      />

      {/* Testimonials Section */}
      <section className="pb-2 py-md-0">
        <div className="container">
          {/* Section Header */}
          <div className="text-center max-w-2xl mx-auto mb-4 mb-md-5">
            <span className="text-info text-uppercase fw-bold tracking-wider small">
              Client Reviews
            </span>
            <h2 className="fs-2 fw-bold text-dark mt-1">
              WHAT OUR <span style={{ color: "#BD06D3" }}>CLIENTS SAY</span>
            </h2>
            <p className="text-muted small">
              Real feedback from our trusted investors and customers.
            </p>
          </div>

          {/* Cards Grid */}
          <div className="row g-3 g-md-4 justify-content-center">
            {reviews.map((r, i) => (
              <div className="col-12 col-md-6 col-lg-4" key={i}>
                <div className="card border-0 shadow-sm p-4 rounded-4 bg-white h-100 d-flex flex-column justify-content-between hover-top transition">
                  <div>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <FaQuoteLeft style={{ color: "#BD06D3" }} size={28} />
                      {/* Star Ratings */}
                      <div className="text-warning d-flex gap-1">
                        {[...Array(r.rating)].map((_, index) => (
                          <FaStar key={index} size={14} />
                        ))}
                      </div>
                    </div>
                    <p
                      className="fst-italic text-muted mb-4 small fs-md-6"
                      style={{ minHeight: "60px" }}
                    >
                      "{r.text}"
                    </p>
                  </div>

                  {/* User Info with Profile Image */}
                  <div className="d-flex align-items-center gap-3 pt-3 border-top">
                    <img
                      src={r.image}
                      alt={r.name}
                      className="rounded-circle object-fit-cover border border-2 border-info"
                      style={{ width: "50px", height: "50px" }}
                    />
                    <div>
                      <h6 className="fw-bold text-dark mb-0">{r.name}</h6>
                      <small className="text-info font-medium">{r.role}</small>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Sister Concerns */}
      <div className="py-4">
        <SisterConcerms />
      </div>
    </div>
  );
};

export default Testimonials;
